import { isMobile } from "../common";
import Dropdown from "./Dropdown";

export function FilterTab({
  options,
  selected,
  onClick,
  isSecondary,
  onResultOptions,
  isRounded,
  isSingle,
}: {
  options: string[];
  selected: string[];
  isSecondary?: boolean;
  isRounded?: boolean;
  isSingle?: boolean;
  onClick?: (option: string, index: number) => void;
  onResultOptions?: (options: string[]) => void;
}) {
  const handleSelection = (option: string, index: number) => {
    if (onClick) {
      onClick(option, index);
    }
    if (onResultOptions) {
      if (selected.includes(option)) {
        if (selected.length === 1) {
          onResultOptions(options); // Reset to all options if only one is selected
        } else {
          onResultOptions(selected.filter((item) => item !== option)); // Remove the selected option
        }
      } else {
        onResultOptions([...selected, option]); // Add new option to selection
      }
    }
  };

  return isSingle && isMobile ? (
    <Dropdown
      options={options}
      selected={selected[0]}
      onSelect={(option: string, index: number) => {
        handleSelection(option, index); // Use the same logic here
      }}
    />
  ) : (
    <div className="flex">
      {options.map((option, index) => (
        <div
          key={option}
          onClick={() => handleSelection(option, index)} // Reuse handleSelection here as well
          className={
            "tab " +
            (isRounded ? "tab-rounded " : "") +
            (selected.includes(option) && options.length !== selected.length
              ? "tab-active"
              : "") +
            (index === 0
              ? " tab-left "
              : index === options.length - 1
              ? " tab-right "
              : "") +
            (selected.includes(option) &&
            isSecondary &&
            options.length !== selected.length
              ? " tab-secondary"
              : "")
          }
        >
          {option}
        </div>
      ))}
    </div>
  );
}

export function getResultFilterOptions(
  options: string[],
  currentlySelected: string[],
  selected: string
): string[] {
  if (currentlySelected.includes(selected)) {
    if (currentlySelected.length === options.length) {
      return [selected];
    }
    if (currentlySelected.length === 1) {
      return options;
    } else {
      return currentlySelected.filter((item) => item !== selected);
    }
  } else {
    return [...currentlySelected, selected];
  }
}

export function FilterHeadingTab({
  options,
  selected,
  onClick,
  isSecondary,
  onResultOptions,
  isRounded,
  isSingle,
}: {
  options: {
    headline: string;
    tabs: string[];
  }[];
  selected: string[];
  isSecondary?: boolean;
  isRounded?: boolean;
  isSingle?: boolean;
  onClick?: (option: string, index: number) => void;
  onResultOptions?: (options: string[]) => void;
}) {
  const handleSelection = (option: string, index: number) => {
    if (onClick) {
      onClick(option, index);
    }
    if (onResultOptions) {
      if (selected.includes(option)) {
        if (selected.length === 1) {
          onResultOptions([]); // Reset to all options if only one is selected
        } else {
          onResultOptions(selected.filter((item) => item !== option)); // Remove the selected option
        }
      } else {
        onResultOptions([...selected, option]); // Add new option to selection
      }
    }
  };

  return (
    isMobile ?  <Dropdown
    options={options.flatMap((value) => value.tabs)}
    selected={selected[0]}
    onSelect={(option: string, index: number) => {
      handleSelection(option, index); // Use the same logic here
    }}
  /> :
<div className="flex-container gap-x-2">
  {options.map((values) => {
    return  (
      <div className="tab-container">
        {values.tabs.length > 1 && <div className="tab-headline">{values.headline}</div>}

        <div className="tabs-wrapper">
          {values.tabs.map((option, index) => (
            <div key={option}>
              <div
                onClick={() => handleSelection(option, index)}
                className={`tab 
                  ${isRounded ? "tab-rounded" : ""} 
                  ${values.tabs.length === 1 && "tab-round tab-single"}
                  ${selected.includes(option) && options.length !== selected.length ? "tab-active" : ""} 
                  ${index === 0 ? "headtab-left" : ""} 
                  ${index === values.tabs.length - 1 ? "headtab-right" : ""} 
                  ${selected.includes(option) && isSecondary && options.length !== selected.length ? "tab-secondary" : ""}`}
              >
                {option}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  })}
</div>
  );
}
